import React, { useState } from 'react';
import './App.css';
import logo from './assets/images/logo.png';
import { Link, useNavigate } from 'react-router-dom';
import { toast, Bounce } from 'react-toastify';
import { existEmail, sendVerifyOtp, changePassword } from './helper/apiHelper.js'
import { useLoading } from './context/LoadingContext';


function Create() {
    const [otp, setOtp] = useState(new Array(6).fill(''));
    const [isOtpSent, setIsOtpSent] = useState(false);
    const [isOtpVerified, setIsOtpverified] = useState(false);
    const [email, setEmail] = useState('');
    const { showLoader, hideLoader } = useLoading();
    const [password, setPassword] = useState('');
    const [c_password, setCPassword] = useState('');
    const history = useNavigate();

    const handleChange = (element, index) => {
        if (isNaN(element.value)) return;
        const newOtp = [...otp];
        newOtp[index] = element.value;
        setOtp(newOtp);

        if (element.nextSibling && element.value) {
            element.nextSibling.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !otp[index] && e.target.previousSibling) {
            e.target.previousSibling.focus();
        }
    };

    const otpSend = async () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email) {
            toast.error("Please fill the email field.", {
                position: "top-center",
                transition: Bounce,
            });
            return;
        }

        if (!emailRegex.test(email)) {
            toast.error("Please enter a valid email address.", {
                position: "top-center",
                transition: Bounce,
            });
            return;
        }
        const checkEmail = await existEmail(email);
        if (checkEmail && checkEmail.exists) {
            await sendOtpEmail();
        } else if (checkEmail && !checkEmail.exists) {
            toast.error("Email not exist.", {
                position: "top-center",
                transition: Bounce,
            });
            return;
        }
    }
    const sendOtpEmail = async () => {
        showLoader();
        const sentOtp = await sendVerifyOtp('sent', email)
        if (sentOtp) {
            toast.success("OTP sented", {
                position: "top-center",
                transition: Bounce,
            });
            setIsOtpSent(true);
        } else {
            toast.error("Something went wrong", {
                position: "top-center",
                transition: Bounce,
            });
        }
        hideLoader();
    }

    const verifyOtp = async () => {
        const otpValue = otp.join('');
        showLoader();
        const sentOtp = await sendVerifyOtp('verify', email, otpValue)
        if (sentOtp) {
            toast.success("OTP verified", {
                position: "top-center",
                transition: Bounce,
            });
            setIsOtpverified(true);
        } else {
            toast.error("Invalid otp", {
                position: "top-center",
                transition: Bounce,
            });
        }
        hideLoader();
    }

    const updatePassword = async () => {
        if (!password) {
            toast.error("Please fill the password field.", {
                position: "top-center",
                transition: Bounce,
            });
            return;
        }

        if (password.length < 8) {
            toast.error("Password must be at least 8 characters long.", {
                position: "top-center",
                transition: Bounce,
            });
            return;
        }

        if (password !== c_password) {
            toast.error("Password and confirm password should be same.", {
                position: "top-center",
                transition: Bounce,
            });
            return;
        }
        showLoader();
        const response = await changePassword(password, email);
        if (response) {
            toast.success("Password updated successfully", {
                position: "top-center",
                transition: Bounce,
            });
            history('/');
        } else {
            toast.error("Something went wrong", {
                position: "top-center",
                transition: Bounce,
            });
            history('/');
        }
        hideLoader();
    }
    return (
        <div className='d-flex justify-content-center align-items-center min-vh-80'>
            <div className='col-8 login-section'>
                <div className='row'>
                    <div className='col d-flex flex-column align-items-center justify-content-center'>
                        <img src={logo} alt='logo' width="88" height="70" />
                        <p className='x-bold'>Forgot Password</p>
                        <p className='s-gray-text position-relative text-truncate'>{isOtpSent ? (isOtpVerified ? 'Create new password' : '6-digit OTP Confirmation') : 'Enter your email to send otp'}</p>
                    </div>
                    <div className='col d-flex flex-column align-items-center justify-content-center mt-90'>
                        {!isOtpSent && <><input className='email-input mt-4' type='email' placeholder='Your E-mail' value={email} onChange={(e) => { setEmail(e.target.value) }} />
                        </>}
                        {isOtpVerified &&
                            <>
                                <input className='password-input mt-4' type='password' placeholder='New Password' value={password} onChange={(e) => {
                                    let value = e?.target?.value?.trim();
                                    setPassword(value)
                                }} />
                                <input className='password-input mt-4' type='password' placeholder='Confirm Password' value={c_password} onChange={(e) => {
                                    let value = e?.target?.value?.trim();
                                    setCPassword(value)
                                }} />
                            </>
                        }
                        {isOtpSent && !isOtpVerified &&
                            <div>
                                <span>We have sent you a <b>6-digit</b> code
                                    to<b>********@{email.split('@')[1]}</b></span>
                                <div className='d-flex align-items-center justify-content-center gap-3 mt-3'>
                                    {otp.map((value, index) => (
                                        <input
                                            key={index}
                                            type="text"
                                            maxLength="1"
                                            value={value}
                                            onChange={(e) => handleChange(e.target, index)}
                                            onKeyDown={(e) => handleKeyDown(e, index)}
                                            style={{

                                            }}
                                            className='otp-input'
                                        />
                                    ))}
                                </div>
                                <button className='signup-btn gradient-bg mt-4 otp-text' onClick={async () => { await verifyOtp() }}>Verify</button>
                                <div className='resend-otp-section mt-3 d-flex justify-content-center'>
                                    <span className='continue-text'>Didn't Get The Code? </span><span className='continue-text gradient-text cursor-pointer fw-bold' onClick={async () => { await sendOtpEmail() }}>Resend</span>
                                </div>
                            </div>
                        }
                        {isOtpVerified && <button className='signup-btn gradient-bg mt-4 otp-text' onClick={async () => { await updatePassword() }}>Update password</button>}
                        {!isOtpSent && <> <button className='otp-btn mt-4' onClick={async () => {
                            await otpSend()
                        }}><span className='otp-text'>Send Otp</span></button>
                        </>
                        }
                        <div className='mt-4'>
                            <span className='continue-text'>Do you have an account? </span><span className='continue-text gradient-text cursor-pointer fw-bold' onClick={() => {
                                history("/");
                            }}>Login</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Create;
